import React, { useContext } from 'react'
import { ReactComponent as ProteinDesign } from '../../../../assets/icons/protein-design.svg'
import { ReactComponent as ProteinDiscovery } from '../../../../assets/icons/protein-discovery.svg'
import { ReactComponent as ProteinOptimization } from '../../../../assets/icons/protein-optimization.svg'
import { FormattedMessage } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import SectionWithTag from '../../../../components/SectionWithTag'
import PaddingContext from '../../../../utils/PaddingContext'
import ApplicationNotes from './components/ApplicationNotes'

const id = 'page.applications.segments'

const segments = [
    {
        id: 'design',
        icon: <ProteinDesign />,
    },
    {
        id: 'optimization',
        icon: <ProteinOptimization />,
    },
    {
        id: 'discovery',
        icon: <ProteinDiscovery />,
    },
]

const Segments = () => {
    const { padding } = useContext(PaddingContext)
    return (
        <div className='bg-white py-12 md:py-30 relative border-t border-black/10'>
            <SectionWithTag
                tag={{ id: `${id}.tag` }}
                className='3xl:max-w-screen-2xl mx-auto'
                padding={padding}
            >
                <div className='flex md:flex-row flex-col items-center md:gap-x-12 py-9 md:py-16 md:pt-0 md:pb-20 gap-y-8 md:gap-y-0 justify-between'>
                    <div className='md:max-w-[520px]'>
                        <FormattedMessage id={id} tagName='h2' />
                    </div>
                    <div className='md:max-w-[410px]'>
                        <FormattedMessage id={`${id}.description`} tagName='p' />
                    </div>
                </div>
            </SectionWithTag>
            <div style={{ ...padding }} className='side-padding 3xl:max-w-screen-2xl mx-auto'>
                {segments.map(({ icon, id: segmentId }, index) => (
                    <div
                        key={segmentId}
                        className={twMerge(
                            'flex md:items-center gap-y-6 justify-between w-full py-6 md:py-10 border-black/10 md:flex-row flex-col',
                            index === 0 ? 'border-y' : 'border-b',
                        )}
                    >
                        <div className='flex items-center md:gap-x-24 gap-x-2'>
                            <icon.type className='w-12 h-12 md:w-16 md:h-16 flex-shrink-0' />
                            <div className='md:w-[185px] text-2xl flex-shrink-0'>
                                <FormattedMessage id={`${id}.${segmentId}`} />
                            </div>
                        </div>
                        <span className='max-w-[410px] text-sm'>
                            <FormattedMessage id={`${id}.${segmentId}.description`} tagName='p' />
                        </span>
                    </div>
                ))}
            </div>
            <div style={{ ...padding }} className='side-padding 3xl:max-w-screen-2xl mx-auto'>
                <ApplicationNotes />
            </div>
        </div>
    )
}

export default Segments
